import Folder from '../store/schema/Folder';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getEffectiveFolderDisplayName(folder: Folder): string {
    if (!folder) {
        return '';
    }

    if (getUserConfiguration().SessionSettings.IsShadowMailbox && folder.remoteFolderDisplayName) {
        return folder.remoteFolderDisplayName;
    }

    return folder.DisplayName;
}
